import type { AnyObjectSchema } from 'yup'

type IsRequiredField = (_: { fieldName: string; validationSchema: AnyObjectSchema }) => boolean

export const isRequiredField: IsRequiredField = ({ fieldName, validationSchema }) => {
  const field = validationSchema.describe().fields[fieldName] as {
    tests: Array<{
      name: string
    }>
  } | null
  return !!field && field.tests.findIndex(({ name }) => name === 'required') >= 0
}
